// @ts-nocheck
export const localeCodes =  [
  "en",
  "it",
  "fr"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_89d99a87",
      load: () => import("#nuxt-i18n/89d99a87" /* webpackChunkName: "locale_en_46json_89d99a87" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_8abf72c2",
      load: () => import("#nuxt-i18n/8abf72c2" /* webpackChunkName: "locale_it_46json_8abf72c2" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_c736f619",
      load: () => import("#nuxt-i18n/c736f619" /* webpackChunkName: "locale_fr_46json_c736f619" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "it",
    name: "Italiano",
    language: undefined
  },
  {
    code: "fr",
    name: "Français",
    language: undefined
  }
]
/** client **/

/** client-end **/